import type { ProviderId } from "@@/shared/providers/provider-id";
import { isProviderId } from "@@/shared/providers/provider-id";
import { unique } from "@@/utilities/unique";
import { parseScope } from "./parse-scope";

const parseProviderIdsFromUserScopes = (user: {
    scopes: string[];
}): ProviderId[] => {
    const providerOwnerScopes = unique(
        user.scopes
            .map(parseScope)
            .filter(parsed => parsed.permission === "owner")
            .filter(parsed => isProviderId(parsed.segments[0]))
            .map(parsed => parsed.segments[0] as ProviderId),
    );

    return providerOwnerScopes;
};

export { parseProviderIdsFromUserScopes };
